import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";

export default function Footer() {
  return (
    <div className="footer">
      <div className="footer-content">
        <Link to="/admin/contact" className="footer-link">
          Kontaktirajte nas
        </Link>
        <span className="footer-separator">|</span>
        <span>© 2026 PIXELS2PIXELS. All rights reserved.</span>
      </div>
    </div>
  );
}
